var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"simple-marquee max-w"},[_c('div',{staticClass:"content"},[_c('h1',{staticClass:"style-h1"},[_vm._v(_vm._s(_vm.block.title))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }